'use strict';

// Constructor
var Header = function() {
    $( document ).ready(function() {
        var popup = $('.popup');
        var close = $('.popup__close');
        var body = $('body');

        setTimeout(function(){
            popup.addClass('-open');
            body.addClass('-hideOverflow');
        }, 500);

        close.on('click', function() {
            popup.removeClass('-open');
            body.removeClass('-hideOverflow');
        });
    });
};

module.exports = Header;
